import { useContext, useState } from 'react';

import { NextLink } from '@/atoms';

import { InitPropsProvider } from '@/components/providers';
import { useCart, useCartDispatch } from '@/lib/hooks';
import { routes } from '@/lib/routes';
import Button from '../button';

import type { TypeCardTribu } from './types';

export const CardTribu = ({
  TopIcon,
  HeaderIcon,
  headerTitle,
  advantages,
  color,
  showSubscriptionButton = false,
  showRegisterButton = false,
}: TypeCardTribu) => {
  const {
    options: { tribuAmantesArtesanos },
  } = useContext(InitPropsProvider);

  const [loading, setLoading] = useState(false);
  const { add } = useCartDispatch();
  const { loading: cartLoading } = useCart();

  return (
    <div className="w-full max-w-xs">
      {TopIcon && (
        <div className="relative z-10">
          <TopIcon className="mx-auto" />
        </div>
      )}
      <div
        style={{ borderColor: color }}
        className={`flex flex-col overflow-hidden rounded-t-2xl border ${TopIcon ? '-mt-8' : ''}`}
      >
        <div
          style={{ backgroundColor: color }}
          className={`relative flex flex-col items-center justify-center gap-2 px-4 ${TopIcon ? 'pb-6 pt-10' : 'py-6'} `}
        >
          <HeaderIcon />
          {headerTitle && (
            <p className="u-body u-body--s font-light text-typo-primary">
              {headerTitle}
            </p>
          )}
        </div>
        <div className="p-4">
          <p className="u-body u-body--s text-typo-primary">
            {advantages.title}
          </p>

          <ul className="ml-2 mt-2 space-y-2">
            {advantages.advantages.map((advantage, key) => (
              <li key={key} className="u-body u-body--xs text-typo-primary">
                {advantage}
              </li>
            ))}
          </ul>

          {showRegisterButton && (
            <div className="mt-4 flex items-center justify-center">
              <NextLink href={routes.micuenta.index} passHref>
                <Button
                  as="a"
                  style={{ backgroundColor: '#DADADA', color: 'black' }}
                >
                  registrarme
                </Button>
              </NextLink>
            </div>
          )}

          {showSubscriptionButton && (
            <div className="mt-4 flex flex-col items-center justify-center gap-2">
              <span className="u-body u-body--xs font-bold italic">
                Por solo 19,90€ al año
              </span>
              <Button
                style={{ backgroundColor: '#DADADA', color: 'black' }}
                loading={loading || cartLoading}
                disabled={loading || cartLoading}
                onClick={() => {
                  if (!tribuAmantesArtesanos?.product?.databaseId) return;

                  setLoading(true);
                  add({
                    productId: tribuAmantesArtesanos.product.databaseId,
                    quantity: 1,
                  })
                    .catch(() => null)
                    .finally(() => setLoading(false));
                }}
              >
                suscribirme
              </Button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
